import { apiCall } from './gqlClient';

const GETGROUPS_QUERY = `
  query getGroups($type: String!) {
    getGroups(type: $type)
    {
      id
			providerId
			name
			color
			counter
			type
      ...fragments
    }
  }`;

export const getGroupsApiCall = async ({type}, fragments = null) => apiCall({ query: GETGROUPS_QUERY, variables: {type}, fragments });

const GETALLPROVIDERGROUPS_QUERY = `
  query getAllProviderGroups {
    getAllProviderGroups
    {
      id
			providerId
			name
			color
			counter
			type
      ...fragments
    }
  }`;

export const getAllProviderGroupsApiCall = async (fragments = null) => apiCall({ query: GETALLPROVIDERGROUPS_QUERY, variables: {}, fragments });

const SAVEGROUP_QUERY = `
  mutation saveGroup($name: String!, $type: String!, $color: String!, $id: Int) {
    saveGroup(name: $name, type: $type, color: $color, id: $id)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const saveGroupApiCall = async ({name, type, color, id}, fragments = null) => apiCall({ query: SAVEGROUP_QUERY, variables: {name, type, color, id}, fragments });

const DELETEGROUP_QUERY = `
  mutation deleteGroup($id: Int!, $type: String) {
    deleteGroup(id: $id, type: $type)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const deleteGroupApiCall = async ({id, type}, fragments = null) => apiCall({ query: DELETEGROUP_QUERY, variables: {id, type}, fragments });
